import React, {Component} from 'react';
import ReservationHeader from "../components/ReservationHeader";
import {inject, observer} from "mobx-react";
import {toJS} from "mobx";
import {Redirect, Route} from 'react-router-dom';

@inject(
  'packageStore',
  'reservationStore'
)
@observer
class ReservationProcessPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      reserveDate: [],
      selectedDate: '',
      reserveOptionGroups: [],
      reserveOptionGroupData: [],
      reserveChildOptionGroups: {},
      selectedOptions: {},
      defaultSelectedOptions: [],
      reserveInfo: {},
      reserveData: {},
      isLastChild: false,
      isFinished: false,
      isAllUpdated: false,
      hasEmptyValue: false
    };

    this.reserve = this.reserve.bind(this);
    this.updateSelectedDate = this.updateSelectedDate.bind(this);
    this.updateOptionChild = this.updateOptionChild.bind(this);
  }

  componentDidMount() {
    const {pin} = this.props.location.state;
    this.getReservationDate(pin);
  }

  getReservationDate(pin) {
    const {reservationStore} = this.props;
    reservationStore.setReservationDataList(pin)
      .then(isLoaded => {
        if (!isLoaded) return false;

        const reserveInfo = toJS(reservationStore.getReservationInfo);
        const reserveDate = reservationStore.getReservationDate;
        const defaultSelectedOptions = reserveInfo.reserveOptions.map(({ seq }) => seq);
        const reserveChildOptionGroups = {};
        const selectedOptions = {};
        if(reserveInfo.reserveOptions.length > 0) {
          reserveInfo.reserveOptions.forEach(({ seq }) => {
            reserveChildOptionGroups[seq] = [];
            selectedOptions[seq] = [];
          });
        }

        this.setState({
          reserveDate: reserveDate,
          reserveInfo: reserveInfo,
          reserveOptionGroups: reserveInfo.reserveOptions,
          defaultSelectedOptions,
          reserveChildOptionGroups,
          selectedOptions
        });
      });
  }

  updateSelectedDate(event) {
    const {reservationStore, location} = this.props;
    const {pin, barcode} = location.state;

    const selectedDate = event.target.value;
    if(!selectedDate) {
      this.setState({ hasEmptyValue: true });
      return false;
    }

    const {reserveOptionGroups} = this.state;
    if (reserveOptionGroups.length < 1) {
      this.setState({
        selectedDate,
        isLastChild: true
      });
      return false;
    }

    const copySelectedOptions = {};
    const copyChildOptionGroups = {};
    reserveOptionGroups.forEach(({seq}) => {
      reservationStore.setReservationOptionGroup(pin, seq, selectedDate, barcode)
        .then(res => {
          if (!res) return false;
          const validOptionGroupData = toJS(res);
          copyChildOptionGroups[seq] = [validOptionGroupData];
          copySelectedOptions[seq] = [];

          this.setState({
            reserveChildOptionGroups: copyChildOptionGroups,
            selectedOptions: copySelectedOptions,
            selectedDate
          });
        });
    });
  }

  updateOptionChild(event) {
    const selectedOptionData = event.target.value;
    if(!selectedOptionData) {
      this.setState({ hasEmptyValue: true });
      return false;
    }

    const {reservationStore, location} = this.props;
    const {pin, barcode} = location.state;
    const [optionGroupSeq, childOptionGroupIndex, seq] = selectedOptionData.split('-');

    const {
      selectedDate,
      reserveChildOptionGroups,
      selectedOptions,
    } = this.state;

    const copyReserveChildOptionGroups = Object.assign({}, reserveChildOptionGroups);
    const copySelectedOptions = Object.assign({}, selectedOptions);
    const copySeqSelectedOptions = [...copySelectedOptions[Number(optionGroupSeq)]];
    copySeqSelectedOptions[childOptionGroupIndex] = Number(seq);

    const selectedChildOptionList = copyReserveChildOptionGroups[optionGroupSeq][childOptionGroupIndex];
    const selectedGroupData = selectedChildOptionList.filter(groupData => groupData.seq === Number(seq))[0];
    if(selectedGroupData && selectedGroupData.childCount > 0) {
      reservationStore.setReservationOptionGroup(pin, seq, selectedDate, barcode)
        .then(res => {
          const validOptionGroupData = toJS(res);
          copyReserveChildOptionGroups[Number(optionGroupSeq)].push(validOptionGroupData);
          copySelectedOptions[Number(optionGroupSeq)] = copySeqSelectedOptions;

          this.setState({
            reserveChildOptionGroups: copyReserveChildOptionGroups,
            selectedOptions: copySelectedOptions,
            hasEmptyValue: false
          })
        });
    } else {

      const restoreChildOptionGroup = copyReserveChildOptionGroups[optionGroupSeq].filter((_, index) => index <= childOptionGroupIndex);
      copyReserveChildOptionGroups[Number(optionGroupSeq)] = restoreChildOptionGroup;

      const restoreSelectedOptions = copySeqSelectedOptions.filter((_, index) => index <= childOptionGroupIndex);
      copySelectedOptions[Number(optionGroupSeq)] = restoreSelectedOptions;

      this.setState({
        reserveChildOptionGroups: copyReserveChildOptionGroups,
        selectedOptions: copySelectedOptions,
        hasEmptyValue: false
      });
    }
  }

  reserve() {
    const result = window.confirm('예약하시겠습니까?');
    if (!result) {
      return false;
    }

    const {
      selectedDate,
      selectedOptions,
      defaultSelectedOptions,
      hasEmptyValue,
      reserveChildOptionGroups,
    } = this.state;

    let totalSelectionCount = 0;
    let userSelectionList = [];
    Object.keys(reserveChildOptionGroups).forEach(key => {
      totalSelectionCount += reserveChildOptionGroups[key].length;
    });

    Object.keys(selectedOptions).forEach(key => {
      userSelectionList = userSelectionList.concat(selectedOptions[key]);
    });

    if(!selectedDate) {
      alert('날짜를 선택해주세요.');
      return false;
    }

    if(hasEmptyValue) {
      alert('옵션을 모두 선택해주세요.');
      return false;
    }

    if(totalSelectionCount !== userSelectionList.length) {
      alert('옵션을 모두 선택해주세요.');
      return false;
    }

    const {reservationStore, location, } = this.props;
    const {pin} = location.state;
    const reservationInfo = reservationStore.getReservationInfo;
    const orderDetailSeq = reservationInfo.orderDetailSeq;
    const allSelectedOptions = userSelectionList.concat(defaultSelectedOptions);

    reservationStore.callReservation({ pin, orderDetailSeq, selectedDate, selectedOptions: allSelectedOptions })
      .then(_ => {
        this.setState({ isFinished: true });
      })
  }

  render() {

    const {pin, barcode} = this.props.location.state;
    const {
      reserveDate,
      reserveInfo,
      isFinished,
      reserveChildOptionGroups,
      reserveOptionGroupData,
      reserveOptionGroups,
      selectedDate,
      defaultSelectedOptions
    } = this.state;

    const { alreadyReserved } = reserveInfo;
    if (alreadyReserved || isFinished) {
      return (
        <Route render={() => (
          <Redirect
            to={{
              pathname: `/result/${barcode}/reserve/${pin}`,
              state: {barcode, pin}
            }}
          />
        )}/>
      )
    }

    return (
      <div className="App fade">
        <ReservationHeader/>
        <div className="App-container">
          <div className="group-items">
            <form>
              <div className="box-item" style={{marginBottom: '100px', paddingBottom: '50px' }}>
                <h3 className="item-title" style={{ height: '70px', lineHeight: '70px', textAlign: 'center' }}>예약 정보 선택하기</h3>
                <div
                  className="item-content"
                  style={{height: '50px', borderBottom: '1px solid #d8d8d8', paddingLeft: '20px', lineHeight: '50px'}}
                >이름: {reserveInfo.customNm}</div>
                <div
                  className="item-content"
                  style={{height: '50px', borderBottom: '1px solid #d8d8d8', paddingLeft: '20px', lineHeight: '50px'}}
                >핸드폰 번호: {reserveInfo.customCell}</div>
                <div
                  className="item-content"
                  style={{
                    paddingTop: '25px',
                    paddingBottom: '25px',
                    height: '100%', borderBottom: '1px solid #d8d8d8', paddingLeft: '20px', lineHeight: '1.3'}}
                >{reserveInfo.realItemNm}</div>
                <div
                  className="item-content"
                  style={{height: '50px', borderBottom: '1px solid #d8d8d8', paddingLeft: '20px', lineHeight: '50px'}}
                >예약 날짜</div>
                <div
                  className="item-content"
                  style={{height: '50px', borderBottom: '1px solid #d8d8d8', paddingLeft: '20px', lineHeight: '50px'}}
                >
                <select name="days" style={{height: '50px', width: '100%'}}
                                onChange={this.updateSelectedDate}>
                            <option defaultValue={''} value="">날짜를 선택해주세요.</option>
                          {reserveDate.map(date => <option key={date} value={date}>{date}</option>)}
                        </select>
                </div>
                {selectedDate !== '' && reserveOptionGroups
                && reserveOptionGroups.length > 0
                && reserveOptionGroups.map((optionGroup, index) => {
                  const optionSequence = optionGroup.seq;
                  const childOptionGroups = reserveChildOptionGroups[optionSequence];

                  return (
                    <React.Fragment key={index}>
                      <div
                        className="item-content"
                        style={{
                          height: '50px',
                          borderBottom: '1px solid #d8d8d8',
                          paddingLeft: '20px',
                          lineHeight: '50px',
                          display: 'flex'
                        }}
                      >
                        <div>{optionGroup.optionNm}</div>
                      </div>
                      {
                        childOptionGroups
                        && childOptionGroups.length > 0
                        && childOptionGroups.map((optionSelectGroup, selectIndex) => {
                          optionSelectGroup.sort((a, b) => (a.sort - b.sort));
                          return(
                            <div
                              key={selectIndex}
                              className="item-content"
                              style={{
                                height: '50px',
                                borderBottom: '1px solid #d8d8d8',
                                padding: '20px',
                                lineHeight: '50px',
                                display: 'flex'
                              }}
                            >
                            <span style={{display: 'inline-block', flex: 1}}>
                              <select name={`childOption-${index}`}
                                      style={{height: '50px', width: '100%'}}
                                      onChange={this.updateOptionChild}>
                                  <option defaultValue={''} value="" >옵션을 선택해주세요.</option>
                                {
                                  optionSelectGroup
                                  && optionSelectGroup.length > 0
                                  && optionSelectGroup.map(({ optionNm, seq }) => <option key={seq} value={`${optionSequence}-${selectIndex}-${seq}`}>{optionNm}</option>)}
                              </select>
                          </span>
                            </div>
                          )
                        })
                      }
                    </React.Fragment>
                  )
                })}
                {reserveOptionGroupData
                && reserveOptionGroupData.length > defaultSelectedOptions.length
                && reserveOptionGroupData.map((groupDataList, index) => {
                  if(index > 0) {
                      return(
                        <div
                          className="item-content"
                          key={index}
                          style={{
                            height: '50px',
                            borderBottom: '1px solid #d8d8d8',
                            padding: '20px',
                            lineHeight: '50px',
                            display: 'flex'
                          }}
                        >
                            <span style={{display: 'inline-block', flex: 1}}>
                              <select name={`childOption-${index}`}
                                      style={{height: '50px', width: '100%'}}
                                      onChange={this.updateOptionChild}>
                                  <option defaultValue={''} value="" >옵션을 선택해주세요.</option>
                                {
                                  groupDataList
                                  && groupDataList.length > 0
                                  && groupDataList.map(({ optionNm, seq }) => <option key={seq} value={`${index}-${seq}`}>{optionNm}</option>)}
                              </select>
                          </span>
                        </div>
                      )
                  }

                  return null;
                })}
              </div>
            </form>
            <div style={{
              position: 'fixed',
              right: 0,
              bottom: 0,
              width: '100%',
              height: '70px',
              background: '#312a53',
              zIndex: 20,
              lineHeight: '70px',
              textAlign: 'center',
              fontSize: '1.2em',
              fontWeight: 'bold',
              color: '#fff'
            }}
                 onClick={this.reserve}
            >
              <span>예약하기</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReservationProcessPage;


// WEBPACK FOOTER //
// ./src/pages/ReservationProcessPage.jsx